module.exports = __webpack_public_path__ + "img/file.82273fa4.png";